export default __webpack_public_path__ + "images/Tapclicks.9472a1b1fc73387ad905b04a9eebab67.svg";